import { BannerText } from 'components/BannerText'
import { useTranslation } from 'hooks/useTranslation'
import {
  VetQuoteContent,
  Quote,
  Attribution,
  AttributionText,
} from './VetQuote.styles'

export const VetQuote = () => {
  const { t } = useTranslation()

  return (
    <BannerText background="secondary-500">
      <VetQuoteContent>
        <Quote>{t('products-v2:freeze-dried-raw-nuggets.vet-quote.quote')}</Quote>
        <Attribution>
          <AttributionText size='h4' font='label' weight='regular'>
            {t('products-v2:freeze-dried-raw-nuggets.vet-quote.attribution-name')}
          </AttributionText>
          <AttributionText size='h4' font='label' weight='regular'>
            {t('products-v2:freeze-dried-raw-nuggets.vet-quote.attribution-title')}
          </AttributionText>
        </Attribution>
      </VetQuoteContent>
    </BannerText>
  )
}

VetQuote.displayName = 'VetQuote'
